import { Button } from "primereact/button";
import { useFormState } from "react-hook-form";

export function ContinueButton({
  onClick,
  loading,
  disabled,
}: {
  onClick: () => void;
  loading: boolean;
  disabled: boolean;
}) {
  const { isValid } = useFormState();
  return (
    <Button
      className="w-full justify-content-center border-round-lg mt-3"
      onClick={onClick}
      disabled={!isValid || disabled}
      loading={loading}
    >
      Continue
    </Button>
  );
}
